export const SESSION_INVALID_KEY = "SESSION_INVALID"
const SESSION_STORAGE_EVENT = "session-storage"
const REDIRECT_URL_KEY = "REDIRECT_URL"
const IS_LOGGING_OUT_LOCK_KEY = "IS_LOGGING_OUT_LOCK"
const RELOAD_FALLBACK_VERSION_KEY = "SW_RELOAD_FALLBACK_VERSION"
const HAS_ENTERED_APP_KEY = "HAS_ENTERED_APP"

export const SessionStorageService = {
    setRequireReAuthentication: () => sessionStorage.setItem("REQUIRE_RE_AUTHENTICATION", "true"),
    getRequireReAuthentication: () => !!sessionStorage.getItem("REQUIRE_RE_AUTHENTICATION"),

    // a lock to differentiate between 1) user is currently logging out and 2) unauthorized user paste a url
    // if 1) in login page, skip setRedirectUrl
    // if 2) after redirecting to login page, setRedirectUrl so user can be redirected to the original page
    setIsLoggingOut: () => sessionStorage.setItem(IS_LOGGING_OUT_LOCK_KEY, "true"),
    getIsLoggingOut: () => !!sessionStorage.getItem(IS_LOGGING_OUT_LOCK_KEY),
    clearIsLoggingOut: () => sessionStorage.removeItem(IS_LOGGING_OUT_LOCK_KEY),

    markAppEntered: () => sessionStorage.setItem(HAS_ENTERED_APP_KEY, "true"),
    hasEnteredApp: () => !!sessionStorage.getItem(HAS_ENTERED_APP_KEY),
    clearAppEntered: () => sessionStorage.removeItem(HAS_ENTERED_APP_KEY),

    getSessionInvalid: () => sessionStorage.getItem(SESSION_INVALID_KEY),

    setSessionInvalid: () => {
        if (SessionStorageService.getSessionInvalid() === null) {
            sessionStorage.setItem(SESSION_INVALID_KEY, "true")
            window.dispatchEvent(new Event(SESSION_STORAGE_EVENT))
        }
    },

    clearSessionInvalid: () => {
        sessionStorage.removeItem(SESSION_INVALID_KEY)
        window.dispatchEvent(new Event(SESSION_STORAGE_EVENT))
    },

    // caps the service worker reload fallback at one attempt per running version, so a
    // failed update cannot reload the same build over and over
    markReloadFallbackAttempted: (version: string) => sessionStorage.setItem(RELOAD_FALLBACK_VERSION_KEY, version),
    hasAttemptedReloadFallback: (version: string) => sessionStorage.getItem(RELOAD_FALLBACK_VERSION_KEY) === version,

    setRedirectUrl: (url: string) => sessionStorage.setItem(REDIRECT_URL_KEY, url),
    getRedirectUrl: () => sessionStorage.getItem(REDIRECT_URL_KEY),
    clearRedirectUrl: () => sessionStorage.removeItem(REDIRECT_URL_KEY),

    clear: () => sessionStorage.clear(),
}
